import { mount } from "@vue/test-utils";
import Paso3 from "@/views/Paso3";

jest.mock("@/views/Paso3", () => ({
  ...jest.requireActual("@/views/Paso3"),
  __esModule: true,
  default: {
    montoMaximo: "mockedValue"
  }
}));

describe("Paso3 test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(Paso3);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component Paso3", () => {
    expect(wrapper).toBeDefined();
  });
});
